import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';

export const usePaymentLinkDistribution = () => {
  const {
    state: { hasActiveDistributionMethods },
    actions: { updateApplicationContext },
  } = useApplicationContext();

  const setHasActiveDistributionMethods = (hasActiveDistributionMethods: boolean) => {
    updateApplicationContext({ hasActiveDistributionMethods });
  };

  return { hasActiveDistributionMethods, setHasActiveDistributionMethods };
};
